export const SetLotToAvailable = (firebase, projectCode, lotActive) => {
	console.log('SetLotToAvailable lotActive', lotActive);
	try {
		firebase
			.database()
			.ref('/kavtek_clients/' + projectCode + '/lots/')
			.child(lotActive)
			.child('available')
			.set('available');
	} catch (error) {
		console.error(error);
	}
};
